import React from "react";
const infoCards = [
  {
    title: "Our Mission",
    description:
      "To simplify access to capital for Indian businesses by delivering structured, transparent, and execution-focused advisory services.",
  },
  {
    title: "Our Values",
    description:
      "Integrity in every mandate. Discipline in structuring. Commitment to closure. We measure our success by the quality of transactions we deliver, not the number of mandates we hold.",
  },
  {
    title: "Our Edge",
    description:
      "Pan-India lender relationships, sector-agnostic expertise, and a team that has advised on transactions across real estate, manufacturing, infrastructure, and technology.",
  },
];
export default function AboutSection() {
  return (
    <div id="about">
      <section className="py-16 lg:py-24 bg-white">
        <div className="container mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
            {/* Left Content */}
            <div>
              <span className="uppercase  text-sm text-[#D6B34D] font-medium">
                Who We Are
              </span>

              <h2 className="mt-4 text-4xl md:text-5xl  leading-tight text-slate-900 ">
                Built on relationships.
                <br />
                Driven by results.
              </h2>

              <div className="w-16 h-[2px] bg-[#D6B34D] mt-8 mb-10"></div>

              <div className="space-y-8 text-gray-500 text-base leading-7">
                <p>
                  Y&B Capital is a specialist capital advisory firm helping
                  Indian businesses navigate the full spectrum of debt, equity,
                  and structured finance. We work with promoters, CFOs, and
                  business owners to design and execute funding strategies that
                  align with their growth objectives.
                </p>

                <p>
                  With deep relationships across banks, NBFCs, private credit
                  funds, and equity investors, we serve as a single point of
                  contact for all capital requirements—from working capital
                  lines to large project financings and PE fundraises.
                </p>

                <p>
                  Our approach is transaction-first: we engage only when we can
                  add meaningful value, and we remain involved from mandate to
                  disbursement.
                </p>
              </div>
            </div>

            {/* Right Content */}
            <div className="space-y-6">
              {/* Chart */}
              <div className="rounded-xl overflow-hidden">
                <img
                  src="/chartImg.png"
                  alt="Capital Growth"
                  className="w-full h-full object-cover"
                />
              </div>

              {infoCards.map((item, index) => (
                <div
                  key={index}
                  className="flex bg-slate-50 rounded-md overflow-hidden"
                >
                  <div className="w-1.5 bg-[#D6B34D]"></div>

                  <div className="p-4">
                    <h3 className="text-2xl font-serif text-slate-900 mb-4">
                      {item.title}
                    </h3>

                    <p className="text-gray-500 leading-6 text-sm">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
